import React from 'react'
import { useFilteredCompanyOptions } from '../hooks/use-filtered-company-options'
import SearchFieldBase, { BasicProps } from 'src/Libs/inputs/formik/SearchFieldBase'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

type Props = Omit<BasicProps, 'label'>

/**
 * Input field for company names that asynchroniously fetches data filtered by the input
 */
const CompanySearch = (props: Props): React.ReactElement => {
  const { fetchFilteredCompanies } = useFilteredCompanyOptions()
  const { t } = useCustomTranslation()

  return <SearchFieldBase {...props} label={t('common.companyName')} fetchFilteredValues={fetchFilteredCompanies} />
}

export default CompanySearch
